import { ISelectType } from "@4uhub/lib4uhub";

export const verticalOptions: ISelectType[] = [
  { id: "UNDEFINED", name: "Não Informado" },
  { id: "OTHER", name: "Outro" },
  { id: "AUTO", name: "Automotivo" },
  { id: "BEAUTY", name: "Beleza, Spa e Salão" },
  { id: "APPAREL", name: "Vestuário e Roupas" },
  { id: "EDU", name: "Educação" },
  { id: "ENTERTAIN", name: "Entretenimento" },
  { id: "EVENT_PLAN", name: "Planejamento de Eventos" },
  { id: "FINANCE", name: "Finanças e Bancos" },
  { id: "GROCERY", name: "Alimentos e Mercearia" },
  { id: "GOVT", name: "Serviço Público e Governamental" },
  { id: "HOTEL", name: "Hotelaria e Hospedagem" },
  { id: "HEALTH", name: "Saúde e Medicina" },
  { id: "NONPROFIT", name: "Organização sem Fins Lucrativos" },
  { id: "PROF_SERVICES", name: "Serviços Profissionais" },
  { id: "RETAIL", name: "Varejo e Compras" },
  { id: "TRAVEL", name: "Viagens e Transportes" },
  { id: "RESTAURANT", name: "Restaurante" },
  { id: "ALCOHOL", name: "Bebidas Alcoólicas" },
  { id: "OTC_DRUGS", name: "Medicamentos de Venda Livre" },
  { id: "ONLINE_GAMBLING", name: "Jogos de Azar Online/Apostas" },
  { id: "PHYSICAL_GAMBLING", name: "Jogos de Azar Físicos" },
];
